// Karelerin bittiği ilerleme oranı — LaserFrameHero (Home'a özel, 486 karelik
// yükleyici) ve Navbar (kareler bitince navbar "geçildi" sayar) ortak kullanır.
//
// PERFORMANS: Bu değer eskiden LaserFrameHero.tsx'in içinde export edilip
// Navbar'dan import ediliyordu. Navbar HER sayfada eager mount olduğu için bu
// tek import, window.load+idle'a özenle ertelenmiş 377 satırlık kare-yükleme
// modülünün TAMAMINI main.js'e sürüklüyordu — Home'a özel optimizasyon,
// modülün eager grafiğe bağlı olması yüzünden diğer tüm sayfalarda da main
// bundle boyutuna ekleniyordu. Sabit bu bağımsız dosyada durunca Navbar,
// LaserFrameHero'nun geri kalanını hiç görmeden yalnızca sayıyı alır.
export const FRAME_END = 0.66;
